import { InitialState } from '../state';
import { AppReducer } from './app-reducer';

export const resetUserSuggestionReducer: AppReducer<'ResetUserSuggestion'> = (
    state = InitialState.ResetUserSuggestion,
    action
): typeof state => {
    switch (action.type) {
        case 'ResetSuggestion/Load/Started':
            return {
                ...state,
                deleteUserLoading: true,
                deleteUserSuccess: false,
                errorCode: '',
              
            };
        case 'ResetSuggestion/Load/Succeeded':
            return {
                ...state,
                deleteUserLoading: false,
                deleteUserSuccess: true,  
                errorCode: '',             
            };
        case 'ResetSuggestion/Load/Failed':
            return {
                ...state,
                deleteUserLoading: false,
                deleteUserSuccess: false,
                errorCode: action.payload.errorCode
               
            };
        case 'AlarmAcknowledgement/Load/Unmounted':
            return {
                ...state,
                deleteUserLoading: false,
                deleteUserSuccess: false,
                errorCode: '',
                        
            };
        default:
            return state;
    }
};
